import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SiteProvider } from "@/context/SiteContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingActions from "@/components/FloatingActions";
import Home from "@/pages/Home";
import Categories from "@/pages/Categories";
import CategoryDetail from "@/pages/CategoryDetail";
import ProductsList from "@/pages/ProductsList";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Manufacturing from "@/pages/Manufacturing";
import BlogList from "@/pages/BlogList";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import Catalogue from "@/pages/Catalogue";
import { Dealers } from "@/pages/Apply";

const ScrollTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="jt-container text-center py-20">
      <div className="eyebrow">404 — Tool not in this kit</div>
      <h1 className="mt-2 font-display font-black uppercase text-5xl">Page not found</h1>
      <a href="/" className="mt-6 inline-flex jt-btn jt-btn-primary">Back to Home</a>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <ScrollTop />
          <Header />
          <main data-testid="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/manufacturing" element={<Manufacturing />} />
              <Route path="/products" element={<ProductsList />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/category/:slug" element={<CategoryDetail />} />
              <Route path="/product/:slug" element={<ProductDetail />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/catalogue" element={<Catalogue />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dealers" element={<Dealers />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <FloatingActions />
          <Footer />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
